<template>
  <div
    v-if="passwordTokenConfirmed"
    class="columns is-centered content"
  >
    <div class="column is-8">
      <div class="box">
        <div v-if="!passwordReset">
          <validation-observer
            ref="form-password-update"
            tag="form"
          >
            <div class="columns is-multiline">
              <div class="column is-full has-text-centered">
                <h2 class="title is-2">
                  Reset Password
                </h2>
                <div class="subtitle is-2">
                  Your password must be at least 12 characters long and contain the following: upper case (A-Z), lower case (a-z), number (0-9) and special character (e.g. !@#$%^&*).
                </div>
              </div>
              <div class="column is-half">
                <textbox-vee
                  id="password-new"
                  v-model="newPassword"
                  type="password"
                  placeholder="New Password"
                  rules="required|phlpass"
                  autocomplete="off"
                  required
                  vid="password-new"
                />
              </div>
              <div class="column is-half">
                <textbox-vee
                  id="password-confirm"
                  v-model="newPasswordRepeat"
                  type="password"
                  rules="required|confirmed:password-new"
                  placeholder="Repeat New Password"
                  autocomplete="off"
                  required
                />
              </div>
              <div class="column is-full has-text-centered">
                <button
                  id="update-btn"
                  class="button is-primary"
                  type="button"
                  :class="isUpdating ? 'is-loading' : ''"
                  :disabled="isUpdating"
                  @click="resetPassword"
                >
                  Update Password
                </button>
              </div>
            </div>
          </validation-observer>
        </div>
        <div
          v-else
          class="columns is-multiline"
        >
          <div class="column is-full has-text-centered">
            <h2 class="title is-2">
              Password Reset
            </h2>
            <div class="subtitle is-2">
              Your password has been reset. Proceed to login.
            </div>
          </div>
          <div class="column is-full has-text-centered">
            <router-link :to="{ name: 'login' }">
              <button
                id="login-btn"
                type="button"
                class="button is-primary"
              >
                Login
              </button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    v-else
    class="columns is-centered"
  >
    <div class="column is-6">
      <div class="box">
        <div>
          <div class="columns">
            <div class="column has-text-centered">
              <h2 class="title is-2">
                Expired link!
              </h2>
            </div>
          </div>
          <div class="columns">
            <div class="column has-text-centered">
              <p>The link you are using has expired. Please contact support if you are having issues resetting your password.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Textbox } from '@phila/phila-ui';
import { withValidation } from 'vee-validate';

const TextboxVee = withValidation(Textbox);

export default {
  name: 'ResetPassword',
  components: {
    TextboxVee,
  },
  data() {
    return {
      passwordTokenConfirmed: false,
      isUpdating: false,
      password: '',
      newPassword: '',
      newPasswordRepeat: '',
      passwordReset: false,
    };
  },
  async created () {
    let data = {
      filerId: this.$route.query.filerId,
      emailToken: this.$route.query.emailToken,
    };

    if (data.filerId && data.emailToken) {
      this.passwordTokenConfirmed = await this.$store.dispatch('login/confirmPasswordResetToken', data);
    }
  },
  methods: {
    async resetPassword () {

      this.isUpdating = true;

      let isValid = await this.$refs['form-password-update'].validate();

      if (!isValid) {
        this.isUpdating = false;
        return false;
      }

      let resetInfo = {
        filerId: parseInt(this.$route.query.filerId),
        emailToken: this.$route.query.emailToken,
        password: this.newPassword,
      };

      let request = await this.$store.dispatch('admin/resetUserPassword', resetInfo);

      if (request) {
        this.isUpdating = false;
        this.passwordReset = true;
      } else {
        this.isUpdating = false;
        return false;
      }

    },
  },
};
</script>
